<template>

    <div>

        <!-- Toolbar !-->
        <b-button-toolbar class="mb-1">
            <template v-for="(btn,key) in toolbar">
                <b-button :key="key" class="mr-1" @click="clickButton(btn)">{{btn.title}}</b-button>
            </template>
        </b-button-toolbar>

        <table class="grid-view">
            <thead>
            <th>x</th>
            <template v-for="(obj, alias) in columns">
                <th :key="alias" v-if="obj.show ? obj.show() : true" @click="clickSorting(alias)" :class="'sorting-'+sorting[alias]">
                    {{obj.title}}<span class="sort"></span>
                </th>
            </template>
            </thead>
            <tbody>
            <template v-for="(row, idx) in rows">
                <tr :key="idx">
                    <td><input type="checkbox" v-model="selection" :value="idx"/></td>

                    <template v-for="(obj, alias) in columns">
                    <td :key="alias" v-if="columns[alias].show ? columns[alias].show() : true"  @click="clickValue(row, alias, idx)"><span v-html="renderCell(row, alias, idx)"></span></td>
                    </template>
                </tr>
            </template>
            </tbody>
        </table>

    </div>

</template>

<style lang="scss">

    .grid-view {
        width: 100%;
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .grid-view {
        .sorting-1 .sort:after {
            content: ' [v]';
        }

        .sorting-2 .sort:after {
            content: ' [^]';
        }

        th {
            background-color: #eee;
        }

        td, th {
            border-right: 1px solid #ddd;
            border-bottom: 1px solid #ddd;
            text-align: center;
        }
    }

</style>

<script>

    import Vue from 'vue'
    export default {
        components: {},
        props: ["columns", "rows", "toolbar", "primary"],
        data() {
            return {
                sorting: {},
                selection: []
            }
        },

        methods: {

            /**
             * Render cell
             */
            renderCell(row, field, index)
            {
                // Call handler
                if (this.columns[field] && this.columns[field].view) return(this.columns[field].view(row, field, index));

                // Return data
                return row[field];
            },

            /**
             * Click on row
             * @param field
             * @param index
             */
            clickValue(row, field, index) {
                // Call handler
                if (this.columns[field] && this.columns[field].click) this.columns[field].click(row, field, index);
            },

            /**
             * Click on row
             * @param field
             * @param index
             */
            clickSorting(field) {

                // Switch current sorting mode
                switch ((this.sorting[field] ? this.sorting[field] : 0)) {
                    case 0:
                        Vue.set(this.sorting, field, 1);
                        break;
                    case 1:
                        Vue.set(this.sorting, field, 2);
                        break;
                    case 2:
                        Vue.set(this.sorting, field, 0);
                        break;
                }

                // Call handler
                if (this.columns[field] && this.columns[field].sorting) this.columns[field].sorting(field, this.sorting[field]);
            },

            /**
             * Click button
             * @param btn
             */
            clickButton(btn)
            {
                // Check for confirmation
                if(btn.confirm && !confirm(btn.confirm)) return;

                // Init objects
                let objs = [];

                // Add objects
                for(let i of this.selection)
                {
                    // Add only present results
                    if(this.rows[i]) objs.push(this.rows[i]);
                }

                // Checking for required option
                if(objs.length == 0 && btn.required)
                {
                    // Show error message
                    alert("Please select at least one item.");
                    return;
                }

                // Execute click
                if(btn.method) btn.method(objs);
            }
        }
    }

</script>
